module.exports = __webpack_public_path__ + "static/media/04.42954e64.jpg";